import { makeStyles } from "@material-ui/core";
import { colors } from "global/react-mui/theme/colors";

const useStyles = makeStyles((theme) => ({
	formControl: {
		// margin: theme.spacing(1),
		margin: 0,
		minWidth: 120,
	},
	formControlFull: {
		minWidth: '100%',
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
	label: {
		[theme.breakpoints.down('md')]: {
			color: colors["text-grey"],
		}
	},
	select: {
		[theme.breakpoints.down('md')]: {
			'&::before': {
				borderColor: colors["text-grey"],
			},
			'&:hover::before': {
				borderColor: 'rgba(255, 255, 255, 1) !important'
			},
			'& svg': {
				color: '#d3dbe8'
			},
			color: '#d3dbe8',
		},
	},
	validationWrapper: {
		padding: 12,
		color: colors["wolf-red"],
	},

}));

export default useStyles
